import ErrorBoundary from "./ErrorBoundary";
import FallbackPage from "./FallbackPage";

export { FallbackPage };
export default ErrorBoundary;
